import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import TextInput from 'components/ui/TextInput';
import { useFormik } from 'formik';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { authenticationApi } from 'redux/reducers/auth';
import { useTraineeRegMutation, useUpdateSomeTraineeDetailMutation } from 'redux/reducers/user';
import { useAppDispatch } from 'redux/store/store';
import validations from 'utils/validation';
import * as Yup from 'yup';

import NepaliDatePicker from 'components/ui/Datepicker/Datepicker';
import { BSToAD } from 'components/ui/Datepicker/Datepickerutils';
import CustomSelect from 'components/ui/Editor/CustomSelect';
import getDoaminName from 'lib/getDomainName';
import moment from 'moment';
import { genderOptions } from 'pages/user-private-route/TraineeProfile/PersonalInfo/Schema';
import {
  useListDistrictByProvinceQuery,
  useListProvinceQuery
} from 'redux/reducers/geography';
import { trainingsubdomain } from 'redux/reducers/settings';
import { ITraineeInfo } from './TraineeDataTable';
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

const SignUpValidationSchema = {
  first_name: Yup.string().required('First Name is required'),
  last_name: Yup.string().required('Last Name is required'),
  middle_name: Yup.string().nullable(),
  email: Yup.string().email('Invalid email').required('Email is required'),
  mobile_number: Yup.string()
    .matches(validations.phone.regex, validations.phone.message)
    .required('Mobile Phone is required.'),
  province_id: Yup.string().nullable(),
  district_id: Yup.string().nullable(),
  employee_sn: Yup.string().optional().nullable(),
  passport_number: Yup.string().nullable(),
  working_organization_name: Yup.string().nullable(),
  qualification: Yup.string().nullable(),
  namc_or_nhpc: Yup.string().nullable(),
  recommendation_letter: Yup.mixed().nullable(),
  dob: Yup.string().nullable(),
  citizenship_no: Yup.string().nullable()
};

const initialValue = {
  first_name: '',
  middle_name: '',
  last_name: '',
  gender: '',
  email: '',
  mobile_number: '',
  attendance_pin: '',
  province_id: '0',
  district_id: '0',
  employee_sn: '',
  passport_number: '',
  working_organization_name: '',
  qualification: '',
  namc_or_nhpc: '',
  recommendation_letter: '',
  dob: '',
  citizenship_no: ''
};

interface ITraineeForm {
  formModal: boolean;
  setFormModal: () => void;
  editDetails: (ITraineeInfo & { id: string; attendance_pin: string }) | null;
}

const TraineeForm: FC<ITraineeForm> = ({ formModal, setFormModal, editDetails }) => {
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);

  const [province, setProvince] = useState<any>('');
  const [districts, setDistricts] = useState<any[]>([]);

  const fetchTraineeList = () =>
    dispatch(authenticationApi.endpoints.listTrainee.initiate(undefined, { forceRefetch: true }));
  const { data: provinceList = [] } = useListProvinceQuery({});

  const { data: districtData } = useListDistrictByProvinceQuery(
    {
      provinceId: province,
      page
    },
    {
      skip: !province
    }
  );

  const [trainRegistration, { isLoading: isCreating }] = useTraineeRegMutation();
  const [updateTrainee, { isLoading: isUpdating }] = useUpdateSomeTraineeDetailMutation();
  //   const dynamicFieldsValidations: any = {};
  //   traineeDynamicFields?.map((item: any) => {
  //     dynamicFieldsValidations[item.fieldname] =
  //       item.field_type_details.title === 'number'
  //         ? item.is_required
  //           ? Yup.number().required(`${item.fieldname} is required`)
  //           : Yup.number()
  //         : item.is_required
  //         ? Yup.string().required(`${item.fieldname} is required`)
  //         : Yup.string();
  //   });

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      ...SignUpValidationSchema

      //   ...dynamicFieldsValidations
    }),
    initialValues: initialValue,
    onSubmit: async (values: Partial<typeof initialValue>) => {
      if (editDetails) {
        try {
          await updateTrainee({
            traineeId: editDetails.id,
            body: {
              ...values,
              first_name: values.first_name,
              middle_name: values.middle_name || '',
              last_name: values.last_name,
              email: values.email,
              mobile_number: values.mobile_number,
              attendance_pin: values.attendance_pin,
              province_id: '0',
              district_id: '0',
              employee_sn: '',
            }
          }).unwrap();
          fetchTraineeList();
          toast.success('Trainee profile updated successfully!');
          setFormModal();
          dispatch(
            authenticationApi.util.invalidateTags([{ type: 'traineeList', id: 'PARTIAL-LIST' }])
          );
        } catch (error: any) {

          toast.error(error?.data.message || 'Trainee profile updated failed!');
        }
      } else {
        delete values.attendance_pin;
        values.middle_name = values.middle_name || '';
        trainRegistration(values)
          .unwrap()
          .then(() => {
            toast.success('Trainee Added');
            setFormModal();
            dispatch(
              authenticationApi.util.invalidateTags([{ type: 'traineeList', id: 'PARTIAL-LIST' }])
            );
          })
          .catch((err: any) => {
            if (err.data.email.length) {
              toast.error(err.data.email[0]);
              return;
            }
            toast.error(err.data?.message);
          });
      }
    }
  });
  console.log(formik.errors);

  useEffect(() => {
    if (editDetails) {
      formik.resetForm({
        values: {
          ...initialValue,
          ...editDetails
        }
      });
    }
  }, [editDetails]);

  useEffect(() => {
    if (districtData) {
      setDistricts((oldData) => [...oldData, ...districtData?.districts]);
    }
  }, [districtData]);

  useEffect(() => {
    setProvince(formik.values.province_id);
  }, [formik.values.province_id]);

  const siteName = getDoaminName();

  return (
    <Modal
      title={`${editDetails ? 'Update' : 'Create'} Trainee`}
      isModalOpen={formModal}
      closeModal={setFormModal}
      renderFooter={() => (
        <div className="hstack gap-2 justify-content-end">
          <SecondaryButton onClick={setFormModal} title="Close" />
          <PrimaryButton
            title={`${editDetails ? 'Update' : 'Create'}`}
            iconName={`${editDetails ? '' : 'ri-add-line'} align-bottom me-1`}
            type="submit"
            isLoading={isCreating || isUpdating}
            onClick={formik.handleSubmit}
          />
        </div>
      )}>
      <div className="row">
        <TextInput
          label="First Name"
          name="first_name"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.first_name}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <TextInput
          label="Middle Name"
          name="middle_name"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.middle_name}
          onBlur={formik.handleBlur}
          formik={formik}
          disableRequiredValidation
        />

        <TextInput
          label="Last Name"
          name="last_name"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.last_name}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <CustomSelect
          label="Gender"
          options={genderOptions}
          value={formik.values.gender}
          onChange={(val: any) => formik.setFieldValue('gender', val)}
          required
        />
        <div className="col-4 mt-3">
          <NepaliDatePicker
            className=""
            containerClassName=""
            label="DOB"
            name="dob"
            onChange={(e) => {
              formik.setFieldValue('dob', e);
              formik.setFieldValue('dob_ad', moment(BSToAD(e)).format('YYYY-MM-DD'));
            }}
            value={formik.values.dob}
          />
        </div>
        <TextInput
          label="Citizenship No"
          name="citizenship_no"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.citizenship_no}
          onBlur={formik.handleBlur}
          formik={formik}
        />

        <TextInput
          label="Email"
          name="email"
          type="email"
          onChange={formik.handleChange}
          value={formik.values.email}
          onBlur={formik.handleBlur}
          formik={formik}
        />

        <TextInput
          label="Mobile No"
          name="mobile_number"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.mobile_number}
          onBlur={formik.handleBlur}
          formik={formik}
          disableRequiredValidation
        />
        <div className="row">
          {siteName == trainingsubdomain && (
            <div className="mt-3 col-md-4">
              <div className="mb-3">
                <label htmlFor="province" className="form-label">
                  Province
                </label>
                <select
                  name="province_id"
                  id="province"
                  className="form-select col-md-12"
                  data-choices
                  data-choices-sorting="true"
                  value={formik.values.province_id}
                  onChange={(e) => {
                    setPage(1);
                    setDistricts([]);
                    formik.handleChange(e);
                  }}>
                  <option selected>Choose...</option>
                  {provinceList.map((province, index) => {
                    return (
                      <option key={index} value={province.id}>
                        {province.name_en}
                      </option>
                    );
                  })}
                </select>

                {formik.touched?.province_id && formik.errors?.province_id && (
                  <span className="text-danger">{formik.errors?.province_id}</span>
                )}
              </div>
            </div>
          )}

          {siteName == trainingsubdomain && (
            <div className="mt-3 col-md-4">
              <div className="mb-3">
                <label htmlFor="district" className="form-label">
                  District
                </label>
                <select
                  name="district_id"
                  id="district_id"
                  className="form-select col-md-12"
                  data-choices
                  data-choices-sorting="true"
                  value={formik.values.district_id}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}>
                  <option selected>Choose...</option>
                  {districts &&
                    districts?.length > 0 &&
                    districts?.map((d, index) => {
                      return (
                        <option key={index} value={d.id}>
                          {d.name_en}
                        </option>
                      );
                    })}
                </select>

                {formik.touched.district_id && formik.errors.district_id && (
                  <span className="text-danger">{formik.errors.district_id}</span>
                )}
              </div>
            </div>
          )}

          {siteName == trainingsubdomain && (
            <>
              <TextInput
                label="Employee SN"
                name="employee_sn"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.employee_sn}
                onBlur={formik.handleBlur}
                formik={formik}
                disableRequiredValidation
              />
              <TextInput
                label="Namc / Nhpc"
                name="namc_or_nhpc"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.namc_or_nhpc}
                onBlur={formik.handleBlur}
                formik={formik}
                disableRequiredValidation
              />
              <TextInput
                label="Passport number"
                name="passport_number"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.passport_number}
                onBlur={formik.handleBlur}
                formik={formik}
                disableRequiredValidation
              />
              <TextInput
                label="Qualification"
                name="qualification"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.qualification}
                onBlur={formik.handleBlur}
                formik={formik}
                disableRequiredValidation
              />
              <TextInput
                label="Working organization"
                name="working_organization_name"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.working_organization_name}
                onBlur={formik.handleBlur}
                formik={formik}
                disableRequiredValidation
              />
            </>
          )}

          {editDetails && (
            <TextInput
              label="PIN Code"
              name="attendance_pin"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.attendance_pin}
              onBlur={formik.handleBlur}
              formik={formik}
              disableRequiredValidation
            />
          )}
          <div className="col-4 mt-3">
            <label>Recommendation letter</label>
            <input
              id="profile-img-file-input"
              type="file"
              className="form-control"
              name="image"
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: 'recommendation_letter',
                    value: e.target.files?.[0] ?? null
                  }
                });
              }}
            />
          </div>
          {formik.values.recommendation_letter && (
            <img
              src={formik.values.recommendation_letter}
              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
              alt="user-profile-image"
            />
          )}

          {/* {traineeDynamicFields?.map((item: any) => {
                  return (
                    <>
                      <TextInput
                        label={item.fieldname}
                        name={item.fieldname}
                        type={item.field_type_details.title}
                        onChange={formik.handleChange}
                        //@ts-ignore
                        value={formik.values[item.fieldname]}
                        onBlur={formik.handleBlur}
                        formik={formik}
                      />
                    </>
                  );
                })} */}
        </div>
      </div>
    </Modal>
  );
};

export default TraineeForm;
